import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { obtenerIniciales } from "@/lib/iniciales";
import { cn } from "@/lib/utils";

interface InitialsAvatarProps {
  nombre: string;
  className?: string;
}

/**
 * Avatar de iniciales del DS (tokens `bg-primary/10` / `text-primary`).
 * Ese markup estaba duplicado a mano en varias páginas (Usuarios, Dashboard,
 * AppSidebar) — este componente es la versión canónica y reutilizable.
 */
export function InitialsAvatar({ nombre, className }: InitialsAvatarProps) {
  return (
    <Avatar className={cn(className)}>
      <AvatarFallback className="bg-primary/10 text-primary">
        {obtenerIniciales(nombre)}
      </AvatarFallback>
    </Avatar>
  );
}
